/*
 * @Description: 租客（承租人）列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-06-28 10:04:15
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { message } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config } from '../../axios';
import { dicCustomerStatus, customerType, credentialType } from '../../axios/dictionaries';
import ListAdd from './components/ListAdd';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',          //关键字
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //显示新增/编辑
        }
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="b-1-3" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.ListAddRef.initUserType(1); this.ListAddRef.initPack(); }}>新增企业用户</AuthButton>
                        <AuthButton authkey="b-1-4" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.ListAddRef.initUserType(2); this.ListAddRef.initPack(); }}>新增个人用户</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleEdit: this.handleEdit })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ListAdd
                    onRef={ref => this.ListAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_customer_findCustomerPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleEdit = (id, customerType) => { //编辑
        this.setState({ showAddModal: true });
        this.ListAddRef.loadPack({ id });
        this.ListAddRef.initUserType(customerType);
        this.ListAddRef.initPack();
        this.ListAddRef.postApilogFindPage({id});
    }
}

const searchData = () => [
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: '在证件号码、手机号码内模糊查询'
    },
];

const columns = ({ handleEdit }) => [
    {
        title: '用户类型',
        dataIndex: 'customerType',
        render(text, record, index) {
            let now = customerType.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '名称',
        dataIndex: 'credentialName',
        render(text, record, index) {
            return text || record.name
        }
    },
    {
        title: '证件类型',
        dataIndex: 'credentialType',
        render(text, record, index) {
            if (record.customerType === 1) {
                return '营业执照'
            } else {
                let now = credentialType.find(item => item.value === text);
                if (now)
                    return <span style={{ color: now.color }}>{now.title}</span>;
                return ''
            }
        }
    },
    {
        title: '证件号码',
        dataIndex: 'credentialNumber'
    },
    {
        title: '手机号码',
        dataIndex: 'phone'
    },
    {
        title: '来源渠道',
        dataIndex: 'shortName'
    },
    {
        title: '二要素',
        dataIndex: 'realNameIdentified',
        render(text, record, index) {
            return text ? "已认证" : '未认证'
        }
    },
    {
        title: '证件影像',
        dataIndex: 'credentialIdentified',
        render(text, record, index) {
            return text ? "已认证" : '未认证'
        }
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicCustomerStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },

    {
        title: '操作',
        dataIndex: 'action',
        width: 100,
        render(text, record, index) {
            return <AuthButton authkey="b-1-2">
                <span className="showClickDetail" onClick={() => { handleEdit(record.id, record.customerType) }}>编辑</span>
            </AuthButton>
        }
    },
];



// WEBPACK FOOTER //
// ./src/page/Customer/List.js